import { AlertTriangle, CheckCircle2 } from "lucide-react";
import { inr, BACKEND_URL } from "@/lib/api";
import { useLoad, PageHead } from "@/components/admin/kit";

const Status = ({ ok, label, need }) => (
  <div className={`flex items-start gap-3 rounded-xl border p-4 ${ok ? "border-emerald-200 bg-emerald-50" : "border-amber-300 bg-amber-50"}`} data-testid={`config-${label.toLowerCase().replace(/\W+/g, "-")}`}>
    {ok ? <CheckCircle2 className="h-5 w-5 shrink-0 text-emerald-700" /> : <AlertTriangle className="h-5 w-5 shrink-0 text-amber-700" />}
    <div className="text-sm"><p className="font-semibold">{label}: {ok ? "Configured" : "NOT configured"}</p>{!ok && <p className="text-xs text-amber-900">{need}</p>}</div>
  </div>
);

export default function Overview() {
  const [s] = useLoad("/admin/stats");
  const [c] = useLoad("/admin/config");
  const cards = s ? [["Applications (all)", s.applications_total], ["Submitted (fee verified)", s.applications_submitted], ["Application fees collected", inr(s.application_fees)],
    ["Product orders", s.orders_total], ["Paid orders", s.orders_paid], ["Product revenue", inr(s.order_revenue)], ["Low-stock variants", s.low_stock]] : [];
  return (
    <div>
      <PageHead title="Overview" />
      {c && (
        <div className="mb-8 grid gap-3 md:grid-cols-2 xl:grid-cols-3">
          <Status ok={c.razorpay} label="Razorpay payments" need="Add PAYMENT_GATEWAY_KEY_ID and PAYMENT_GATEWAY_KEY_SECRET (Razorpay live keys). Until then applicants and customers see a 'payment not configured' message — no payment is simulated." />
          <Status ok={c.razorpay_webhook} label="Razorpay webhook" need={`Add PAYMENT_GATEWAY_WEBHOOK_SECRET and register ${BACKEND_URL}${c.webhook_url_path} in Razorpay (events: payment.captured, payment.failed, order.paid, refund.processed, refund.failed).`} />
          <Status ok={c.sms} label="Mobile SMS OTP" need="Add TWILIO_ACCOUNT_SID, TWILIO_AUTH_TOKEN and TWILIO_VERIFY_SERVICE_SID. Until then mobile numbers are stored as unverified." />
          <Status ok={c.email} label="Email OTP & confirmations" need="Email provider key missing." />
          <Status ok={c.storage} label="Private document storage" need="Storage key missing." />
          {c.razorpay && <Status ok={c.razorpay_mode === "live"} label={`Razorpay mode: ${c.razorpay_mode}`} need="Test keys — no real money is collected." />}
        </div>
      )}
      <div className="grid gap-4 sm:grid-cols-2 xl:grid-cols-4">
        {cards.map(([k, v]) => (
          <div key={k} className="rounded-2xl border border-slate-200 bg-white p-5" data-testid={`stat-${k.toLowerCase().replace(/\W+/g, "-")}`}>
            <p className="text-xs font-semibold uppercase tracking-wider text-slate-500">{k}</p>
            <p className="font-mono-num mt-2 text-2xl font-bold">{v}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
